export default {
  comments: [],
  count: 0
};
